import React from 'react'
import styled from 'styled-components'

const SectionWrapper = styled.section`
  ${props => (props.top ? `padding-top:1.5rem;` : ``)}
`

const Section = ({size = 'lg', ...props}) => <SectionWrapper className={`section-${size}`} {...props} />

export default Section
